module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "text-center",
    staticStyle: {
      "border": "1px solid #fff"
    },
    attrs: {
      "dark": _vm.darkTheme ? _vm.darkTheme : false,
      "elevation": "0",
      "max-width": "350px",
      "height": "200px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "75px!important"
    }
  }, [_c('a', {
    staticClass: "view-link",
    attrs: {
      "href": _vm.url,
      "target": '_blank'
    }
  }, [_c('v-icon', {
    attrs: {
      "size": 50,
      "color": "grey"
    }
  }, [_vm._v("mdi-play-circle-outline")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53cfd877"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/gdrive/GDrivePostView.vue
// module id = 2128
// module chunks = 0